const initialState = {
  navStack: [],
};

export default initialState;
